import React, { useEffect, useState, useContext } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'

import Redirect from '../../components/redirect'
import Intro from '../../components/intro'
import MembershipType from '../../components/membership-type'
import AmountToPay from '../../components/amount-to-pay'
import UpgradeForm from '../../components/upgrade-form'

import MembershipFormContext from '../../context/membership'
import initialValues from '../../data/initialValues'
import validation from '../../validation/membership'
import { setSS, getSS, cleanObject, googleAnalyticsClientID, getUrlParameter } from '../../helpers'


const Homepage: React.FC = (props: any) => {

  const navigate = useNavigate()
  const params = useParams()
  const membershipForm = useContext(MembershipFormContext)
  const membership_form = (window as any).KEW.collections.membership_form[0]
  const [ homepage, setHomepage ] = useState(initialValues.homepage)
  const url = membership_form.private_form ? 'private/' + params.url : params.url
  const paymentType = getUrlParameter('payment_type')
  const type = getUrlParameter('type')

  useEffect(() => {
    if (paymentType && type) {
      document.body.classList.add('hidden')
      const params = { type: type, payment_type: paymentType }
      membershipForm.setPreSelected(params)
      setTimeout(function() {
        if (paymentType === 'regular') {
          (document as any).querySelector('#m-pay-by-dd-button').click()
        }
        if (paymentType === 'single') {
          (document as any).querySelector('#m-pay-by-card-1-button').click()
        }
      }, 200)
    } else {
      membershipForm.setPreSelected(false)
      document.body.classList.remove('hidden')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (!membership_form.status) {
      setTimeout(function() {
        if (membership_form.form_redirect) {
            window.location.href = membership_form.form_redirect
        } else {
            window.location.href = 'https://support.kew.org/';
        }
      }, 5000)
    }
  }, [membership_form])

  useEffect(() => {
    document.body.classList.add('landing')
    document.body.style.backgroundImage = `url(${membership_form.landing_page_background})`
    if (getSS('membership')) {
      setHomepage(getSS('membership'));
    }
  }, [membership_form.landing_page_background, membership_form.name])

  const onSubmit = (data:any) => {
    console.log(data);

    delete data.selected_membership_control
    data.membership_form_id = membership_form.id
    data.membership_form_name = membership_form.name
    data.ga_document_host = (window as any).location.hostname
    data.ga_tracking_id = (window as any).KEW.globals.ga_tracking_id
    data.gtm_container_id = (window as any).KEW.globals.gtm_container_id
    data.initial_location = (window as any).location.href
    data.ga_client_id = googleAnalyticsClientID()

    if (data.payment_type === 'Single' && membership_form.form_type !== 'upgrade') {
      data.amount = data.selected_membership.base_price
      data.payment_method = 'Card/PayPal';
    }
    if (data.payment_type === 'Regular' && membership_form.form_type !== 'upgrade') {
      data.amount = data.selected_membership.base_price - data.selected_membership.direct_debit_discount
      data.payment_method = 'DirectDebit';
    }
    if (membership_form.form_type === 'ingarden') {
      if (data.payment_type === 'CardReader') {
        data.amount = data.selected_membership.base_price
      } else {
        data.amount = data.selected_membership.base_price - data.selected_membership.direct_debit_discount
      }
      console.log(data);
    }
    setSS('membership', data)
    navigate(`/membership/${url}/details`)
  }

  return (
    <>
      { !membership_form?.status &&
        <Redirect />
      }
      { membership_form?.status &&
        <>
          <Formik
            initialValues={ homepage }
            validationSchema={ validation.homepage }
            enableReinitialize={true}
            validateOnChange={false}
            validateOnBlur={false}
            onSubmit={ onSubmit }>
              {(props: any) => {
                props.errors = cleanObject(props.errors)
                return (
                  <>
                    <Form name="membershipForm">
                      <Intro />
                      <div className="row intro-divider"></div>
                      { membership_form.form_type !== 'upgrade' &&
                        <>
                          <MembershipType type={type} paymentType={paymentType} {...props} />
                          <AmountToPay {...props} />
                        </>
                      }
                      { membership_form.form_type === 'upgrade' &&
                        <UpgradeForm {...props} />
                      }
                    </Form>
                  </>
                )
              }}
          </Formik>
        </>
      }
    </>
  )
}

export default Homepage